export const changeIbanApi = {
  changeBankRequisites: 'change-iban-api/changeBankRequisite',
};
